export const DATA_FORMAT = [
  'YYYY-MM-DDTHH:MM:SS.SSSSSSZ',
  'YYYY-MM-DD HH:MM:SS',
  'YYYY-MM-DD',
  'YYYYMMDD',
  // 'TIMESTAMP10',
  // 'TIMESTAMP13',
];

export const DATA_CHECK_STATUS = {
  loading: 'loading',
  disable: 'disable'
};

export const DATE_TYPE_OPTIONS = [
  {
    value: 'YYYYMMDD',
    buttonText: '%Y-%m-%d',
    text: '%Y-%m-%d (2009-01-01)',
  },
  {
    value: 'MMDDYYYY',
    buttonText: '%m-%d-%Y',
    text: '%m-%d-%Y (01-01-2009)',
  },
  {
    value: 'YYYYMM',
    buttonText: '%Y-%m',
    text: '%Y-%m (2009-01)',
  },
  {
    value: 'MMDD',
    buttonText: '%m-%d',
    text: '%m-%d (01-09)',
  },
  {
    value: 'YYYY',
    buttonText: '%Y',
    text: '%Y (2009)',
  },
  {
    value: 'MM',
    buttonText: '%m',
    text: '%m (01)',
  },
  {
    value: 'DD',
    buttonText: '%d',
    text: '%d (09)',
  },
  {
    value: 'YYYYMMDDHHMMSS',
    buttonText: '%Y-%m-%d %H:%M:%S',
    text: '%Y-%m-%d %H:%M:%S (2019-01-01 01:32:10)',
  },
  {
    value: 'YYYYMMDDTHHMM',
    buttonText: '%Y-%m-%d %H:%M',
    text: '%Y-%m-%d %H:%M (2019-01-01 01:32)',
  },
  {
    value: 'MMDDTHHMM',
    buttonText: '%m-%d %H:%M',
    text: '%m-%d %H:%M (01-01 01:32)',
  },
  {
    value: 'HHMMSS',
    buttonText: '%H:%M:%S',
    text: '%H:%M:%S (01:32:10)',
  },
  {
    value: 'HHMM',
    buttonText: '%H:%M',
    text: '%H:%M(01:32)',
  },
];